import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function MetIcon(props: ACIconProps) {
  return <ACIconWrapper {...props} component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
        fill="#D1FADF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.8159 6.84117C14.0547 7.08041 14.0622 7.47606 13.8325 7.72488L8.8325 13.1415C8.717 13.2667 8.55674 13.3361 8.39011 13.3333C8.22349 13.3304 8.06551 13.2555 7.95403 13.1265L6.15403 11.0431C5.93235 10.7866 5.95232 10.3914 6.19863 10.1605C6.44493 9.92955 6.82431 9.95035 7.04598 10.2069L8.41453 11.7909L12.9675 6.85849C13.1972 6.60968 13.577 6.60192 13.8159 6.84117Z"
        fill="#039754"
      />
    </svg>
  );
};
